import EmailDestinatari from "../"

const routes = [
    {name: "EmailDestinatariList", path: "/malattieinfettive/emaildestinatari", component: EmailDestinatari.EmailDestinatariList, meta: { title: "Email Destinatari" } },
    {name: "EmailDestinatariEdit", path: "/malattieinfettive/emaildestinatari/edit/:id", component: EmailDestinatari.EmailDestinatariEdit, meta: { title: "Email Destinatari" } },
]

export default routes;